import { signOut } from 'firebase/auth';
import type { Dispatch } from 'redux';

import {
  userAccessReset,
  userOrgUserReset,
  userProfileReset,
  userSignOutSuccess,
} from '@src/appRedux/actions';
import { auth } from '@src/firebase/firebase';
import { remove } from '@src/packages/utils/storage';

import { clearMarkingPortalSession } from './markingPortal.storage';

/**
 * Signs out a marking-portal session without the global SIGNOUT_USER saga
 * (which reloads the page and races with the profile listener).
 */
export const signOutMarkingPortal = async (dispatch: Dispatch): Promise<void> => {
  clearMarkingPortalSession();
  dispatch(userProfileReset());
  dispatch(userAccessReset());
  dispatch(userOrgUserReset());
  dispatch(userSignOutSuccess());
  remove('user_id');

  try {
    await signOut(auth);
  } catch {
    // Firebase session may already be closed.
  }
};
